import { useState, useEffect } from 'react'
import { Card, Container, ListGroup, ListGroupItem, Row, Col, Button } from 'react-bootstrap'
import hylkyservices from '../services/hylkykortti'
import getCommentingStatus from '../services/comments_toggle'
import 'bootstrap/dist/css/bootstrap.min.css'
import NewCommentForm from './NewCommentForm'

const Comment = ({ comment }) => {
  const cdate = new Date(comment.date).toLocaleString('fi-FI', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  })
  return (
    <ListGroup.Item className="px-0 py-0">
      <Card.Body className="px-2 py-2">
        <Card.Title>{comment.author_name}</Card.Title>
        <Card.Subtitle>{cdate}</Card.Subtitle>
        {comment.content.author_avatar_urls ? <Card.Img src={comment.content.author_avatar_urls} /> : null}
        <Card.Text dangerouslySetInnerHTML={{ __html: comment.content.rendered }} />
      </Card.Body>
    </ListGroup.Item>
  )
}

const Comments = ({ page, commentingEnabled }) => {
  const [comments, setComments] = useState([])
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    const fetchComments = async () => {
      try {
        const newPage = await hylkyservices.getComments(page.id)
        setComments(newPage)
      } catch (error) {
        console.log('Error fetching comments')
      }
    }
    fetchComments()
  }, [page.id])

  return (
    <>
      <Container className="p-0">
        {isOpen && commentingEnabled ? <NewCommentForm pageId={page.id} setIsOpen={setIsOpen} /> : null}
        <Row className="mb-1">
          <Col>
            <h2>Kommentit</h2>
          </Col>
          {!isOpen && commentingEnabled ? (
            <Col className="text-end">
              <Button variant="outline-primary" onClick={() => setIsOpen(true)}>
                Uusi kommentti
              </Button>
            </Col>
          ) : null}
        </Row>
      </Container>
      <Card className="mb-3">
        <ListGroup>
          {comments.length > 0 ? (
            <>
              {comments.map((row) => (
                <Comment key={row.id} comment={row} />
              ))}
            </>
          ) : (
            <ListGroup.Item>Ei kommentteja</ListGroup.Item>
          )}
        </ListGroup>
      </Card>
    </>
  )
}
export default Comments
